export const PREFIXO_DO_EVENTO_DE_RECARGA = 'loadingFilters';

export function nomeDoEventoDeRecarga(path) {
  const caminho = String(path ?? '');
  const sufixo = caminho.replace('/', '').replace('_', '-');

  return `${PREFIXO_DO_EVENTO_DE_RECARGA}:${sufixo}`;
}
